module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('a', {
      attrs: {
        "href": tab.href,
        "role": "tab",
        "tabindex": tab.isActive ? 0 : -1,
        "aria-selected": tab.isActive,
        "aria-controls": 'tab-content-' + tab.aliasSlug,
        "id": 'tab-' + tab.aliasSlug
      },
      on: {
        "keydown": function($event) {
          return _vm.focusTab($event)
        },
        "click": function($event) {
          return _vm.selectTab(tab)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(tab.name))])])
  }), 0), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59b92470","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/Tabs.vue
// module id = 943
// module chunks = 1